import { API_INTERNAL_ENDPOINT } from './constants'
import { type schemaType } from './schema'
import { type paramsType } from './paramsSchema'

export type returnType = ApiServerResponse<schemaType>

export default async (params: paramsType): Promise<returnType> => {
  const runtimeConfig = useRuntimeConfig()

  const url = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/${API_INTERNAL_ENDPOINT}`

  const data = await $fetch(url, {
    body: {
      ...params,
    },
    method: 'POST',
  })

  return data as returnType
}
